
import React from 'react';

const ContentLoader: React.FC = () => {
  return (
    <div className="flex justify-center items-center flex-1">
      <div className="animate-spin h-10 w-10 border-4 border-clustr-blue border-t-transparent rounded-full"></div>
    </div>
  );
};

export default ContentLoader;
